import { zodSchemes } from '@approvalmax/utils';
import { CurrencyIsoCode, FixedSide } from 'shared/data/wallets/v1';
import { z } from 'zod';

export const schema = z.object({
    fromCurrency: z.nativeEnum(CurrencyIsoCode),
    toCurrency: z.nativeEnum(CurrencyIsoCode),
    fromAmount: zodSchemes.required.numberField.numberNullable(),
    toAmount: zodSchemes.required.numberField.numberNullable(),
    fixedSide: z.nativeEnum(FixedSide).nullish(),
});
